import { render, staticRenderFns } from "./LastKnownLocation.vue?vue&type=template&id=64e52edf&"
import script from "./LastKnownLocation.vue?vue&type=script&lang=js&"
export * from "./LastKnownLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports